(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ab-subscription-i18n"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.getElementById('ab-subscription-i18n');
  const root = document.getElementById('MainContent');
  if (!configNode || !root || configNode.dataset.ready) return;
  configNode.dataset.ready = 'true';
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const labels = Object.entries(config.labels || {});
  const selector = [
    '.bsub-widget__main-text',
    '.bsub-widget__sub-details-msg',
    '.bsub-widget__sub-details-heading',
    '.bsub-widget__sub-details-desc',
    '[data-bsub-renewal-method]',
    '.bsub-widget__branding',
    '.bsub-widget__policy-link'
  ].join(',');
  const translate = (element) => {
    for (const node of element.childNodes) {
      if (node.nodeType !== Node.TEXT_NODE) continue;
      let value = node.nodeValue;
      for (const [source, target] of labels) {
        if (source === 'Monthly') {
          if (/^\s*Monthly(?=\s*(?:\(|$))/.test(value)) value = value.replace(source, target);
        } else {
          value = value.replace(source, target);
        }
      }
      if (value !== node.nodeValue) node.nodeValue = value;
    }
    if (element.matches('.bsub-widget__policy-link')
      && element.getAttribute('href') === '/policies/subscription-policy') {
      element.setAttribute('href', config.policyPath);
    }
  };
  const scan = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const parent = node.parentElement;
      if (parent?.matches(selector)) translate(parent);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) translate(node);
    node.querySelectorAll(selector).forEach(translate);
  };
  scan(root);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') scan(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(root, { childList: true, subtree: true, characterData: true });
})();
  } catch(e) { console.error(e); }
})();

})();
